import NoData from '@/components/no-data';
import ConfigDialog from '@/components/config-dialog';
import moment from 'moment';

const mixinTable = {
  components: {
    NoData,
    ConfigDialog,
  },
  data() {
    return {
      tableData: [], // 表格数据
      tableCurPage: 1, // 当前页
      tablePageSize: 10, // 每页条数
      tableTotal: 0, // 总条数
      tableLoading: false, // 表格加载
      rowTemp: {}, // 暂存row数据(如删除操作)
      delDialogVisible: false, // 删除弹窗
      configDialogVisible: false, // 是否显示弹窗
    };
  },
  // keep-alive进入
  activated() {},
  // keep-alive离开(隐藏RankCardDetail, 显示页面其他组件)
  deactivated() {},
  computed: {},
  created() {
    this.init();
  },
  mounted() {},
  filters: {
    filterTime(value) {
      return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  methods: {
    // 初始化
    init() {
      this.tablePageSize = this.g_pageSizeDefault; // 初始化每页条数
      this.getTaleData();
    },
    // 切换页触发事件
    currentChangeFun(e) {
      this.tableCurPage = e;
      this.getTaleData();
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.tablePageSize = e;
      this.getTaleData();
    },
    /** 重置刷新表格
     * @description: 如其他页面回调刷新本页面, true为刷新 false不刷新
     * @param {Boolean} e
     * @return {void}
     */
    reloadTable(e) {
      if (e) {
        this.tableCurPage = 1;
        this.getTaleData();
      }
    },
  },
};

export { mixinTable };
